module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("WINTER")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During a South Louisiana winter, we grow beets, turnips, radishes, carrots, greens, cabbage, broccoli, and cauliflower. We also hunt deer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For me, winter in the South starts after Thanksgiving. It is the rush of building bonfires on the levee, baking for the holidays, attending the boucherie, and smoking meat. The sugarcane has nearly all been harvested, depending on how wet the season has been, and the roads are covered in dust and mud from the cane trucks on their way to the mill. The winter garden is growing well and the harvest is all ready to be picked. Pots of chicken and andouille gumbo and vegetable-beef soup simmer on the stove. Everyone is preparing for their traditional holiday meals, the burning of the bonfires on Christmas Eve, the New Year’s Day meal of luck, and of course Mardi Gras. Traditionally many of these cold weather recipes require smoked meat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Wayne Jacob’s Smokehouse, winter is our busiest season. We prepare the best smoked meats in the way that they have been prepared for centuries in South Louisiana. What would the holidays be without our favorite dishes of gumbo and jambalaya? And what would those dishes be without smoked tasso and andouille?")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P16-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("PICKLED VEGETABLES")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pickled vegetables are my favorite snack. Since almost anything can be pickled, this is one solution to dealing with the bounty of summer and winter gardens. Use them on sandwiches, battered and fried, accompanying white beans and fresh sausage, or in a Bloody Mary.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("6 quarts of vegetables, cut into bite-size pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups white vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. sugar (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. dill seed")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. whole black peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. red pepper flakes")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("12 whole garlic cloves")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. mustard seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. coriander seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup sriracha sauce (optional for spice)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combine all ingredients in a large non-reactive pot (ceramic, glass, or stainless steel) with 1 gallon of water. Boil for 30 minutes. Ladle hot liquid, including seeds and garlic, over fresh vegetables. Either jar the vegetables or let cool in an airtight container then refrigerate.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 6 quarts.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-head"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("TIP:")]), _vm._v(" "), _c('p', {
    staticClass: "box-text"
  }, [_vm._v("YOU CAN PICKLE NEARLY ANY VEGETABLE. SOME OF MY FAVORITES INCLUDE GREEN BEANS, CUCUMBERS, CAULIFLOWER, OKRA, BRUSSELS SPROUTS, RED ONIONS, RADISHES, TURNIPS, GREEN TOMATOES, AND CARROTS.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P19-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("CHEDDAR PECAN CRACKERS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each year on the Sunday before Christmas, thousands of people gather in Jackson Square to sing Christmas carols. When I opened Vacherie Restaurant in the French Quarter, I decided to hold a Christmas open house for family, friends, employees, and neighbors to enjoy holiday treats and eggnog before heading out to sing. Over the years the menu has grown along with the size of the crowd. Some of the original snacks on that menu were Cheddar Pecan Crackers, Hog Head Cheese, and Smoked Chicken Liver Pâté.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1 cup butter, melted")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup pecan pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup black sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("16 oz. sharp Cheddar cheese, grated")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ tbsp. Circle Z Seasoning Mix (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("20 dashes Tabasco")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 350 degrees. In a large bowl combine all ingredients to create a dough. Shape dough by ½ tablespoonfuls into balls and arrange on a baking sheet lined with aluminum foil. Flatten slightly and bake for 20-25 minutes until slightly golden on the edges. Cool before removing from foil.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes about 40 crackers.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P20-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("HOG HEAD CHEESE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every year in January or February, my family holds a boucherie. Hog head cheese is one of the first items started during the festivities because it cooks for hours and then has to set for several more. Cajun pâté is how I explain this dish to “foreigners.” There aren’t many things in life better than a few slices of hog head cheese, a few saltine crackers, spicy pickled vegetables, and a cold beer. This recipe has been adapted to a home kitchen because the original recipe calls for gelatin from the butchered pig’s skin and bones, which may not be readily available from your local market.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1 pork butt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 onion, diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup diced peppers")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("6 garlic cloves, smashed")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. red pepper flakes")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. ground bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. paprika")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("5 green onions, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 red pepper, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup unflavored gelatin dissolved in 4 cups cold water")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fill a large stockpot with 1 gallon of water. Add first 12 ingredients and bring to a simmer. Simmer for at least 2 hours, or until pork falls apart. Remove meat from stock and transfer to a mixing bowl. Roughly chop the meat then mix in green onions and red pepper. Set aside. Strain stock, discarding the vegetables, and return stock to pot. Stir gelatin mixture into the hot stock. Add pork mixture to stock and simmer for 10 minutes. Pour into molds or loaf pans, cover, and refrigerate overnight until firm.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Yields about 8 lb.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-head"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("TIP:")]), _vm._v(" "), _c('p', {
    staticClass: "box-text"
  }, [_vm._v("LEFTOVERS CAN BE FROZEN. ALLOW FROZEN HOG HEAD CHEESE TO THAW IN THE REFRIGERATOR BEFORE USE.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P23-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("SMOKED CHICKEN LIVER PÂTÉ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("People either love liver or they don’t. I don’t, so I tried smoking it. As much as I love smoked meats, I figured the smoking process could only improve the flavor. In fact, it added a great, unexpected aspect to this pâté, which has become a popular holiday item at the smokehouse. Even if you don’t have access to smoked chicken livers, it is still a great recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1 large onion, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ tsp. allspice")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup butter, divided")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. smoked chicken livers")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 eggs, boiled and peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 bunch parsley, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. cognac")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("6 tbsp. heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a large pan over medium heat, sauté onion, allspice, salt, and pepper in 1 tbsp. butter. Add smoked chicken livers and chicken broth. Bring to a boil and then reduce heat to low. Simmer for 10 minutes then remove from heat and allow to cool.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a food processor, chop eggs and parsley until very fine. Add the cooled chicken and onion mixture. Continue processing while slowly adding cognac, heavy cream, and remaining butter. Process until smooth. Turn out into a pan or mold lined with plastic wrap. Chill in the refrigerator until set, at least 3 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 6 cups.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P25-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("South Louisiana residents enjoy a picnic, late 1890s. Courtesy of the Collections of the Louisiana State Museum, 1998.001.16.024")]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("BOUCHERIE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My family looked forward to the yearly boucherie, usually held in early February. As small kids we dressed the night before and slept in our clothes. My dad would get us out of bed wrapped in a blanket at about 4:00 A.M. and carry us to the truck, where we would sleep until awoken by the sound of a .22 gunshot and a pig’s squeals. At that time, we’d put on our shoes—if my dad hadn’t forgotten them—and head out to join the rest of the family. We didn’t want to miss the action.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pig was always killed just before the sun came up. No matter how many times this tradition was carried out, there was always disagreement about the best way to go about it. The definition for boucherie should be the act of killing a pig with too many chefs and not enough helpers. But we always had the same outcome: delicious food for everyone to take home and universal exhaustion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here’s a brief rundown of the process: At about 3:00 A.M., Uncle Jimmy arrives to start boiling the giant pots of water, get coffee going, set up work tables, and sharpen knives. An hour later, the next wave of early people, his brothers and family, show up to unload their cooking pots and critique the way things have been set up. By 5:00 A.M. families arrive with sleeping kids in tow. They help unload and set up while sipping coffee and telling tales of boucheries past. Finally, around 5:30, everyone prepares to shoot the pig. This is always preceded by a discussion on how best to do so as well as a last-minute decision on whether or not the pig will be bled to make blood boudin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once the pig has been dispatched and hung by the hind legs, the pace of things starts to pick up. Curious kids start to emerge from the trucks to investigate the activity. Boiling water is poured over the pig, which is then shaved with a knife to remove its coarse hair. The pig is then cut from tail to neck and its organs carefully removed. If any part of the digestive system is punctured, it could contaminate the meat. The head is removed and moved to a different station to begin making the hog head cheese. The belly is removed and cut into long strips. As kids we were given these strips and very large knives to cut for cracklins. When we finished that important job, we were invited into the house where Aunt Marie-Therese made keks with butter and cane syrup for our breakfast. While we were having breakfast, the cracklins were frying, the hog head cheese was simmering, the blood sausage was getting stuffed, and the meat for the andouille and sausage was getting chopped and ground. Despite any disagreements, each station in the boucherie was always manned and usually people would gravitate toward the same station year after year.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P27-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P28-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Carrying on a tradition: boucheries past and present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("The beer started to flow by about 10:00. By noon the Cajun band had struck up its first chords or someone’s truck radio would be blasting zydeco and swamp pop. Some started to dance in the driveway as they finished their work. As 3:00 P.M. neared, everything but the smoking of the sausage was complete and it was time to rest and have a good time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When my relatives showed up to my recent boucherie, they brought pictures from the 1950 boucherie held at my cousin’s house. The photographs showed my grandparents, unmarried and on their way to a date in Donaldsonville. My great-aunts and great-grandmother were all photographed at their work. It was a pretty amazing surprise to see this history while we carried on the family tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P29-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P30-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("VEGETABLE-BEEF SOUP")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the first sign of a frost, my mom would make one of two things: Vegetable-Beef Soup or Chicken and Andouille Gumbo. I guess what she made depended on whether it was too early to harvest what she needed from the garden or if we were up to our ears in vegetables. Either way we knew the big Magnalite pot was coming out and it would be an all-day thing. However much we ate that day would not even make a dent in the pot’s contents. There was always a lot to freeze and a lot to give away.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("5 tbsp. Circle Z Seasoning Mix, divided (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 tbsp. flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 lb. lean stew meat, cubed")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 strips Wayne Jacob’s bacon, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. celery salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups diced onions")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup sliced green onions")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup diced celery")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup diced bell pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. chopped garlic")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. baby carrots, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("24 oz. canned diced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 oz. tomato paste")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 quarts beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 head of green cabbage, cored and chopped 1 head of broccoli, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ lb. baby lima beans")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ lb. corn")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ lb. baby green beans")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ lb. pasta (I prefer a smaller pasta so it fits on the spoon)")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ lb. frozen peas")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a shallow bowl, combine 2 tbsp. seasoning mix with flour. Dredge stew meat in flour and set aside. In a large soup pot over medium heat, render bacon. When crispy, remove bacon from pot and set aside. Add stew meat to pot and brown in bacon fat. Add celery salt, onions, green onions, celery, bell pepper, garlic, and carrots to pot and sweat until onions are translucent. Mix in diced tomatoes, tomato paste, beef stock, Worcestershire sauce, remaining seasoning mix, and thyme. Carefully add 1 gallon of water. Bring to a boil and add the remaining vegetables. Reduce temperature to low and simmer until beef is tender. Add pasta, peas, and crispy bacon once beef is fork tender. Add more water as needed.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 8 quarts")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-head"
  }, [_vm._v("TIP:")]), _vm._v(" "), _c('p', {
    staticClass: "box-text"
  }, [_vm._v("YOU MAY SUBSTITUTE FROZEN—NOT CANNED— VEGETABLES FOR ANY THAT ARE NOT AVAILABLE FRESH.")])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("WAYNE JACOB’S CHICKEN AND ANDOUILLE GUMBO")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chicken and andouille gumbo is why I do what I do. It is the cornerstone of traditional South Louisiana food. The very act of cooking it is the essence of tradition and community. No one makes a small gumbo, so every time I cook a large pot, I think about the people who will be eating it. I think about the holidays and celebrations enjoyed with gumbo. I think about the customers who are trying it for the first time as well as those who are transported back to their childhoods in their mother’s or grandmother’s kitchen as they taste it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gumbo season starts at the first cool front and lasts until Mardi Gras, with the peak at Christmas. It is the tradition on the Mississippi River to burn bonfires on the levee on Christmas Eve. In most River Parish kitchens, chicken and andouille gumbo simmers on the stove all day, to be enjoyed after the bonfires or even after Midnight Mass. No gumbo would be complete without Coco’s filé. Coco, a Wayne Jacob’s mainstay and nephew of the smokehouse’s original owner, picks the sassafras leaves at just the right time then dries and grinds them to the most vibrant green. I am sure the filé sold commercially contains the same ingredients, but over time the color fades as well as the flavor. With filé, fresh is much better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This recipe is for a traditional Cajun Country gumbo. It differs from New Orleans-style gumbo in that it is thinner and more brothy. You can make it to your liking by adding more or less stock or roux.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1 cup flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup canola oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ large yellow onions, diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 stalks celery, diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 green bell peppers, diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 bunch green onions, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 bunch Italian parsley, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 clove garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. Wayne Jacob’s smoked sausage, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. Wayne Jacob’s andouille, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 lb. Wayne Jacob’s smoked chicken, cubed")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. Circle Z Seasoning Mix (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. gumbo filé")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 quarts chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In an 8 quart pot combine flour and canola oil. Cook over medium heat, constantly stirring and scraping the bottom of the pot until the roux is the color of caramel. Add vegetables and cook until onions are translucent. Stir in sausage, andouille, chicken, Worcestershire, seasoning mixture, and filé and cook until meat starts to caramelize. Add chicken stock and cook, partially covered, over low heat for 3 hours, stirring occasionally.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 6 quarts.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-head"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("TIP:")]), _vm._v(" "), _c('p', {
    staticClass: "box-text"
  }, [_vm._v("OR YOU CAN USE OUR WAYNE JACOB’S GUMBO MIX!")])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("POTATO SALAD")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the River Parishes, we eat our potato salad in our gumbo. This is a very simple recipe, but you can fancy it up by adding whatever extras you like. I don’t really care for crunchy things in my potato salad, but many people add celery, green onions, or fresh parsley.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("2 lb. red potatoes, cubed")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("6 eggs, boiled and peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. dill relish")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. chopped jalapeño peppers")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. Circle Z Seasoning Mix (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup Creole mustard")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a large pot, boil potatoes until fork tender; drain and remove to a large mixing bowl. Mix together remaining ingredients and fold into hot boiled potatoes. Serve as a side or in gumbo.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 3 quarts.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P34-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("WHITE BEANS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of the simplest recipes in the book and takes about five minutes of prep work. I tend to make this dish vegetarian although salt pork, bacon, or sausage are delicious additions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My Mama Bell cooked two pounds of white beans per week throughout her entire adult life. I guess that her German heritage, and the need to feed a family of farmers, led her to prepare hearty meals. She would soak her beans overnight in a bowl on the counter and start cooking them at about 5:00 A.M. Lunch was always ready at 11:00 A.M. sharp. While lunch was cooking, she would do all of her washing and cleaning. I loved waking up to the smell of cooking beans and a roast browning.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1 onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. Navy beans or Great Northern beans, soaked overnight")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. canola oil")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a 6 quart pot over medium heat, sauté onion and seasonings in canola oil until onions are translucent. Add beans and 3 quarts of water to the pot. Bring beans to a boil and then cover and reduce heat to low until beans are creamy, about 2 hours, stirring every 20 minutes to prevent sticking. Beans that are cooked covered on a lower fire will be creamier with less chance of sticking.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 3 quarts.")])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("NEW YEAR’S BLACK-EYED PEAS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My Papa Rene used to swear that eating black-eyed peas on New Year’s Day was the only way to ward off the “red mange.” I have no idea what red mange entails, but it sounds bad enough that I will be eating my peas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Black-eyed peas have more of a muddy flavor than other beans so I cook them with a roux and Wayne Jacob’s smoked sausage. Because this recipe is roux-based, it will have a thicker and more creamy consistency. On the side I always provide smothered cabbage for wealth and cornbread for luck. New Year’s Day is the perfect day for such a healing meal; it wards off the hangover from New Year’s Eve celebrations.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1 smoked ham hock (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup canola oil or bacon grease")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 large onion, diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 bunch green onions, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 bunch Italian parsley, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. Wayne Jacob’s smoked sausage cut into rounds")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. Circle Z Seasoning Mix (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. dried black-eyed peas or 2 lb. frozen or fresh peas")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To make the stock combine 3 quarts water and smoked ham hock in a large pot; bring to a boil then reduce to a simmer. Allow stock to simmer while you prepare the peas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a Dutch oven over medium heat, combine oil and flour to make a roux. Cook, stirring constantly, until the roux turns a caramel color. Stir in onion, green onions, parsley, sausage, seasoning mix, and Worcestershire sauce. Cook until onions are translucent and sausage starts to brown, stirring often to prevent sticking. The longer you fry the sausage in the roux mixture, the more smoke flavor you will enjoy in the final dish. Add the black-eyed peas, stock, and ham hock, and incorporate thoroughly. Simmer for 1 hour or until thickened and black-eyed peas are tender.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 3 quarts.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-head"
  }, [_vm._v("TIP:")]), _vm._v(" "), _c('p', {
    staticClass: "box-text"
  }, [_vm._v("THIS RECIPE IS ALSO GREAT IF YOU SUBSTITUTE RED BEANS FOR BLACK-EYED PEAS. IF YOU DON’T HAVE A HAM HOCK OR DON’T HAVE TIME TO PREPARE YOUR OWN STOCK, SUBSTITUTE PREPARED CHICKEN STOCK IN PLACE OF THE WATER.")])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("CAJUN JAMBALAYA")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s hard to find a festival or fundraiser in South Louisiana where jambalaya isn’t the most anticipated dish. My cousins, my siblings, and I were all in 4-H from age nine to age 18. We raised hogs and sheep—although my dad did 90 percent of the work and paid for all of the actual raising of the animals. We won many awards throughout the years with our show animals because of his hard work, and we got to keep the proceeds from the sale of the animals as our spending money for the year. Our family couldn’t afford much, so we made the most of the yearly district and state livestock shows in Covington and Baton Rouge and treated the time away from school as a vacation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the annual district livestock show, Billy and Joan Lasseigne and Paul and Evelie Scioneaux would make huge pots of delicious Cajun jambalaya and white beans to sell to raise money for the St. James High School Future Farmers of America. They started cooking long before we arrived at 6:00 A.M. I know it was a lot of work, but you could see the pride they took in it and the joy it brought them to cook for everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1 large onion, diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 bunches green onions, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 head celery, diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 green bell peppers, seeded and diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. chopped garlic")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup canola oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. pork, diced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 links Wayne Jacob’s Smoked Sausage, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ link Wayne Jacob’s andouille, quartered and sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. ground pork")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("6 tbsp. Circle Z Seasoning Mix (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 quart chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 quart beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 cups rice, washed thoroughly")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a large Dutch oven over medium heat, sauté chopped onion, green onions, celery, peppers, and garlic in oil until translucent and starting to brown. Mix in next seven ingredients and cook until browned, stirring often to prevent sticking. Add half of each stock to deglaze the pot. Simmer uncovered over medium heat until all meat is fully cooked and most of the liquid has cooked out. Add remaining stock and simmer for 30 minutes uncovered. Check seasoning. The dish should be strongly seasoned to account for the additional liquid and rice to be added. Mix in rice and 4 cups water, stirring to make sure the rice doesn’t stick to the bottom of the pot. Liquid should just cover all of the ingredients. Allow the mixture to return to a simmer and then cover the pot and reduce heat to low. Cook covered for 20 minutes. Remove from heat but allow the dish to rest and do not open the pot for 10 minutes. This will allow any uncooked rice to finish steaming. Remove lid, stir, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 8 quarts.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-head"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("TIP:")]), _vm._v(" "), _c('p', {
    staticClass: "box-text"
  }, [_vm._v("IF YOU PREFER, CHICKEN MAY BE SUBSTITUTED FOR DICED PORK. PARBOILED RICE IS A SAFER OPTION WHEN MULTIPLYING THIS RECIPE. IT’S A LITTLE INSURANCE AGAINST A MUSHY FINISHED JAMBALAYA.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P39-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("STUFFED VENISON ROAST")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("White-tailed deer hunting is a popular tradition in Vacherie and throughout South Louisiana. When hunting any animal, Cajuns kill only what they will eat and use every part of the animal that they can. Venison roast is one of the prized pieces from a deer. Although venison is a very lean meat, if prepared right it will melt in your mouth. I serve this with white beans and Louisiana rice.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1 venison roast")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("6 cloves whole garlic")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ tsp. cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 tbsp. flour, divided")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. canola oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 onion, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 quart homemade deer stock or beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 350 degrees. Clean roast of all connective tissue. Cut slits into each side of roast and insert whole garlic cloves. Season roast with salt, black pepper, and cayenne pepper and dust with 1 tbsp. flour. Heat oil in a braising pot over high heat. Brown roast on all sides then remove from pot and set aside. Add remaining flour to the pot and cook, stirring constantly to make a roux that is caramel in color. Add sliced onion to roux and cook until caramelized. Deglaze the pot with Worcestershire sauce and stock, stirring to release all of the browned bits, or fond, from the bottom of the pot. Return the roast to the pot and cover. Place in oven and cook for about 90 minutes, until roast is fork tender. Slice and serve with the gravy from the pot.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Serves 4")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-head"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("TIP:")]), _vm._v(" "), _c('p', {
    staticClass: "box-text"
  }, [_vm._v("THIS RECIPE ALSO WORKS GREAT FOR BEEF ROASTS.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P41-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("CAULIFLOWER GRATIN")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the Keto diet craze and gluten allergies, cauliflower seems to be the go-to substitute for many foods. Everything from rice to pizza crusts to steaks and burgers have cauliflower as the star impersonator. This is because the flavor of cauliflower is easily masked with seasonings and its texture lends well to different treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My dad always says that he loves to grow a winter garden because he just plants it and it grows. He grows cauliflower and cabbage the size of basketballs, broccoli that produces all winter, and turnips and beets by the truckload.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("2 heads cauliflower (about 8 cups)")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups diced onions")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 cloves garlic, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. Circle Z Seasoning Mix (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. cornstarch or flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups half-and-half")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 425 degrees. Arrange cauliflower in an oven safe baking dish and set aside. In a large pan over medium heat, sauté onions, garlic, and parsley in butter until translucent. Mix in seasonings and cornstarch, stirring constantly until the mixture thickens. Deglaze with wine. Add half-and-half and Parmesan cheese. Stir until thickened. Pour mixture over cauliflower and bake for 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Serves 6.")])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("PARMESAN MASHED TURNIPS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turnips are very easy to grow; you can just scatter the seeds and ignore them. The less attention you pay to them, the better they do. With my harvest, I usually make a beef and turnip stew, but one day I was thinking about the earthy flavor of turnips and realized that Parmesan cheese would be a great complement. This is a full-flavored side for any meat or fish and an alternative use for the incredibly easy-to-grow turnip.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("8 cups turnips, peeled and cubed")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boil turnips until fork tender and drain well. Transfer boiled turnips to a mixing bowl, mash them, and whisk in salt, butter, Parmesan cheese, and cream.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Serves 6.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P44-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("Residents of Edgard, Louisiana, on the banks of a frozen Mississippi River in 1899. Courtesy of the Collections of the Louisiana State Museum, 1998.001.16.036")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P46-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("SLOW COOKER (OR NOT) GRILLADES")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mardi Gras is the time of year when we Louisianans reconnect with our love of this place. All over the state people go all-out to celebrate before Lent. Each region has its own traditions, krewes, costuming, and parades.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the time my siblings and I were very young, my parents would take us to the parades in Metairie. No matter the weather, we were out there with ice chests, insulated camouflage onesies, blankets, and of course the ladder. One year we saw Louise Mandrell on the Sanderson Farms chicken float.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our parade-watching accommodations improved once my brother and I moved to New Orleans. Our landlord and friend, Carlos, would throw a huge party for the Bacchus parade. Complete with a huge spread of food, a brass band, unlimited liquor, and old and new friends, we were based just a few blocks away from the parade route. With the beer keg in a shopping cart, the entire party would migrate to the parade. We carried on this tradition until Hurricane Katrina, when many of our lives took different directions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We always begin Fat Tuesday by blaring “Mardi Gras Mambo” to wake the house. This is not a drill; it is an all-day marathon. I cook many things for Mardi Gras day but either fried chicken, jambalaya, gumbo, or grits and grillades are guaranteed to be on the menu—something warm and filling that we can return to all day. I prep the grillades the night before and put the whole pot in the oven or the slow cooker first thing on Mardi Gras Day.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1 cup oil or bacon fat")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 lb. beef roast (chuck or sirloin tip works great) or pork butt, cut into 4-6 inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups diced onions")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup diced celery")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup diced bell pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup sliced green onions")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("6 oz. canned tomato paste")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("28 oz. canned diced tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 quart beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 tbsp. Circle Z Seasoning Mix (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 350 degrees. In a Dutch oven, prepare the roux by whisking together oil and flour over medium heat, stirring constantly until roux is the color of caramel. Add the roast, cut into pieces, to brown in the roux. To that mixture, add the onions, celery, bell pepper, and green onions. Stir often to prevent sticking. When the vegetables are wilted and translucent, add tomato paste, diced tomatoes, Worcestershire sauce, beef stock, and seasonings. When the mixture returns to a boil, cover and transfer the pot to the preheated oven and cook for 3 hours or until the beef falls apart. Serve over grits (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(" for Perfect Grits).")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 6 quarts.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-head"
  }, [_vm._v("TIP:")]), _vm._v(" "), _c('p', {
    staticClass: "box-text"
  }, [_vm._v("TO PREPARE THE GRILLADES IN A SLOW COOKER, ADD ALL INGREDIENTS IN ORDER TO THE COOKER. COOK ON HIGH SETTING FOR 6-8 HOURS OR UNTIL THE BEEF FALLS APART. SERVE OVER GRITS (SEE INDEX FOR PERFECT GRITS).")])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("SMOKED RABBIT CASSOULET AND COLLARD GREENS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Smoked rabbit cassoulet is a dish that sounds hard but is actually easy to make. It requires only 30 minutes of prep time and the oven does the rest. A great one-pot meal for a cold evening, it contains two of my favorite things: white beans and smoked meat. You can serve it as a soup with French bread, with Louisiana grown rice, or with a side of roasted vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Stock")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 Wayne Jacob’s smoked rabbit, quartered")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 unpeeled onion, quartered")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. black peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("Trimmings from cassoulet vegetables")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Cassoulet")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ lb. cubed bacon or 6 slices bacon, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups diced onions")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups diced celery")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups chopped green onions")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 cups chopped leeks")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 cups sliced carrots")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("12 garlic cloves, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup Circle Z Seasoning Mix (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup brandy")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. white beans")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 bunch parsley, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To make the stock, in a large pot boil rabbit in 6 quarts water for 10 minutes. Remove rabbit from water and set aside to cool. De-bone the rabbit, reserving the meat, and return bones to the pot. Add quartered onion, peppercorns, salt, bay leaf, and vegetable trimmings from the cassoulet to the stock. Return to a boil, allowing the stock to reduce to about 4 quarts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, prepare the cassoulet. In a Dutch oven over medium heat, render bacon until crispy. Remove bacon from the pot and set aside. Add butter and flour to bacon fat, stirring constantly to make a roux about the color of peanut butter. Mix in onions, celery, green onions, leeks, carrots, garlic cloves, seasoning mix, and brandy and cook until onions and leeks are caramelized. Add white beans and 4 quarts stock. Cover and bake at 350 degrees for 3 hours. Stir in chopped parsley after removing from the oven.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Serves 8.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P49-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("COLLARD GREENS WITH SMOKED PORK BELLY")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Growing up, we ate collard greens every once in a while, but my family preferred mustard greens and turnip greens because they were more delicate and, more importantly, we were already growing turnips. Collard greens take a bit more love and work than other greens. The stems have to be removed from fresh collards and since they are thicker, they have to be cooked a bit longer. To me the reward is definitely worth the extra effort.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("2 cups cubed smoked bacon")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 cups diced onions")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 lb. fresh collard greens, stemmed and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. Circle Z Seasoning Mix (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a large pot, render bacon until crispy. Remove from pot and set aside. Sauté diced onions in bacon fat until translucent. Add collard greens, bacon, seasoning mix, and 2 cups water to prevent sticking. Cover and cook over medium heat until greens are tender, about 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Serves 6.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P50-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("KEKS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cultures all over the world have recipes for fried breads. They go by different names, and the most famous version we have locally is a beignet. We referred to the ones we made at home as “keks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My grandmother, Anabell Shexnayder Zeringue, made these for us anytime we would spend the night at her house. We knew we were in for a treat when we’d awaken to the smell of keks frying in her black iron skillet. My father now makes them for us every Christmas morning. We spread butter over them and drizzle them with cane syrup.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("2 cups flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ tsp. baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup buttermilk")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("Oil for frying")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a stand mixer and using a dough hook, combine flour, baking powder, salt, and buttermilk. Mix on low for 8 minutes. Do not cut this time short as the gluten must develop in the dough in order for it to puff when fried. When ready, dough should form a ball around the hook. Remove dough to a floured surface and flatten to ¼-inch thickness. Cut into rectangles measuring approximately 2x6 inches. Cut a slit in the middle of each. Drop individually into deep fryer and fry until golden brown. Serve with whipped butter on top and a side of cane syrup or homemade jam.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes about 30 keks.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P53-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("BOUDIN BREAKFAST STACK")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each week for brunch at Wayne Jacob’s Smokehouse, we experiment with fun specials. We generally feature one Benedict-style stacked dish, one over-the-top sweet dish, and one egg dish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of my favorite stacked dishes involves boudin. Boudin in South Louisiana is one of those humble items that you can find not only at gas stations (and often these are the best-tasting), but also on some of the fanciest menus in the state. It is a mixture of ground pork, liver, rice, and seasonings stuffed into a pork casing. It can be steamed, grilled, or smoked.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("4 boudin links")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remove boudin from the casing and shape into patties. Pan-fry over medium-high heat until outer edges become crisp. Stack them onto a Drop Cracklin Biscuit (see "), _c('span', {
    attrs: {
      "href": "#/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _vm._v(") split in half and top with poached eggs and hollandaise or my Tasso Queso Sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Tasso Queso Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 bunch green onions, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup chopped Wayne Jacob’s tasso")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups milk")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 cups granted pepper Jack cheese")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a 2 quart saucepan over medium heat, whisk together butter and flour. Cook, stirring constantly, until roux just begins to caramelize. Add green onions and tasso and fry in roux for about 5 minutes to release the smoke flavor from the tasso. Whisk in milk to incorporate completely. Add cheese and whisk until smooth and thickened. Use as a dip or topping for breakfast, potatoes, or pasta.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 2 quarts.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-head"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _vm._v("TIP:")]), _vm._v(" "), _c('p', {
    staticClass: "box-text"
  }, [_vm._v("TASSO QUESO SAUCE IS ALSO GREAT AS AN APPETIZER DIP WITH CHIPS OR PORK RINDS.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P55-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _vm._v("DROP CRACKLIN BISCUITS WITH STEEN’S BUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once a year on the day after the boucherie, my mom would chop up the fresh cracklins and add them to her drop biscuit dough. The fat on the small pieces would melt into the dough, leaving the little chunks of meat to stud the biscuit. With a little Steen’s Butter and a hot cup of coffee we had the perfect breakfast. You can enjoy our cracklin biscuits with Steen’s Butter at Wayne Jacob’s Smokehouse ever Sunday for brunch.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("4 cups all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup cracklin crumbs")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup cold butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ cups buttermilk")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 425 degrees. In a large bowl sift together flour, sugar, baking powder, baking soda, and salt. Mix in cracklin crumbs. Grate cold butter into flour and mix well to distribute the butter. Stir in buttermilk. Using an ice cream scoop, space biscuits evenly on baking sheet, leaving room for them to rise in the oven. Bake for 20 minutes or until golden. Serve with Steen’s Butter or homemade jam.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 24 biscuits.")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Steen’s Butter")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup butter, softened")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup Steen’s cane syrup")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whisk together butter and syrup. Spread on warm biscuits. Leftovers can be refrigerated.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes approximately ¾ cup.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P56-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _vm._v("BETTY BOO’S BREAD PUDDING")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Uncle Lewis was Mama Winnie’s brother, and Aunt Betty was his wife. They were wonderful people. He doted on her and they loved being together. He was a big man and she was a short lady. Both were kind, thoughtful, and loving. Aunt Betty was a worrier and whatever Uncle Lewis could do to make her happy and content, he would do. He was an amazing carpenter and a great cook, and he learned both skills from his father.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have a few of my aunt and uncle’s recipes, including a hand-written copy of their bread pudding recipe. Just like gumbo, there are no two bread budding recipes that are the same. Theirs is the basis for the bread pudding I make at my restaurants because I like the lighter texture. Mama Bell added meringue and bananas to hers, but I bake a simpler version that we top with a whiskey sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1½ loaves stale French bread, torn into 1-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("8 cups whole milk")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 cups evaporated milk")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ cups room temperature butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1¾ cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("6 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("28 oz. canned crushed pineapple")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("8 oz. jar maraschino cherries 2 tbsp. cherry juice")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups raisins")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. butternut extract")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. pineapple extract")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. banana extract")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tbsp. lemon extract")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 350 degrees. Arrange French bread in a 9x13 baking dish. Cover with milk and evaporated milk and set aside. In a mixing bowl, cream together butter and sugar until fluffy, then mix in eggs one at a time. Pour over bread. Combine remaining ingredients and then mix into the French bread mixture, incorporating thoroughly. Bake about 1 hour or until puffed and set. Serve with Whiskey Sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Serves 16.")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Whiskey Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4½ cups brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup whiskey")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 eggs, beaten")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a saucepan, melt butter and sugar over medium heat. Remove from heat and stir in whiskey to fully incorporate. Whisk in eggs until sauce is thickened.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes approximately 5 cups.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P59-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _vm._v("ANABELL’S T-GATEAU")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mama Bell would make these iced cookies after Thanksgiving, and we would eat them throughout the holiday season. I still remember playing with the cookie cutters she used. They probably once belonged to her mother and most likely dated from the 1920s. There were farm animals and other shapes, all made of tin. She would make hundreds of these cookies and ice each and every one with pastel icing.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1⅓ cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. vanilla")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 cups flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ tsp. baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Royal Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3½ cups confectioners’ sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. milk")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 325 degrees. In a stand mixer fitted with a flat beater, cream butter and sugar together on medium speed until fluffy then add eggs one at a time. Add remaining ingredients and mix to incorporate. Transfer dough to a floured board and shape into a ball. Wrap with plastic wrap and move to refrigerator to cool. Chill for an hour in the refrigerator, and then roll out on a floured board to about ¼-inch thickness. Cut with cookie cutters and place on a cookie sheet lined with parchment paper. Bake for 8-10 minutes or until lightly browned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To make royal icing, beat confectioners’ sugar and egg whites in a stand mixer with whisk attachment until tripled in volume. Slowly add milk to achieve desired thickness. Add food coloring as desired. Royal icing may be spread or piped onto cooled cookies and will harden as it dries.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 4 dozen cookies.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P60-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _vm._v("100 GOOD COOKIES")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These cookies are addictive. That’s a good thing because this recipe will actually make 100! I recommend keeping them small so they bake to be light and crispy.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("1 cup sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup rice cereal")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup quick oats")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup canola oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 egg")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup coconut")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3½ cups flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. vanilla")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. cream of tartar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¾ tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 350 degrees. In a large bowl, combine all ingredients, mixing well. Drop dough by teaspoonfuls onto ungreased cookie sheet. Bake for 10-15 minutes. When done, cookies will be golden with slightly browned edges.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 100 cookies.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P63-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _vm._v("CHRISTMAS ROCKS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom and dad bake these cookies every year for the holidays. This recipe, like the other recipes in this chapter, makes a lot of cookies. These Christmas Rocks are great to give as gifts, but the spices in them will overpower the flavors of other cookies so be sure to keep them in a separate tin or bag.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("3½ cups flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¾ cup butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ tsp. allspice")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. baking soda dissolved in 1 tbsp. water")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ lbs. pecans, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup chopped dates or raisins")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 325 degrees. In a large bowl, combine all ingredients, mixing well. Drop dough by tablespoonfuls onto a lined baking sheet. Bake for 20 minutes until edges are golden.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 4 dozen cookies.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P65-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _vm._v("DELICIOUS FRUITCAKE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each of my mom’s two brothers has a special fruitcake recipe, but one of them makes his extra special by soaking his cake in whiskey. Here I’ve taken my grandmother’s recipe, added a few updates, and worked that whiskey into the baking process. Add more to soak if you like!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I use two bowls to make this recipe so that the fruit can macerate in the juice and liquor without activating the baking soda and baking powder prematurely.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Bowl 1")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ lb. butter (2 sticks)")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("4 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup molasses")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. vanilla")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 orange, zested and juiced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lemon, zested and juiced")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. lemon extract")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup bourbon")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¼ cup sherry")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Bowl 2")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ cups pecans, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 lb. dates, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup sliced almonds")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 cups golden raisins")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup dried cherries")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups dried apricots")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 cups flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ tsp. cloves")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Bowl 1, whisk together the butter and wet ingredients. Mix in brown sugar and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Bowl 2, toss pecans, dates, almonds, and fruit with flour, baking powder, baking soda, salt, and spices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 275 degrees. Butter and line two 9-inch round pans or one 9x13 baking pan. Pour dry mixture in Bowl 2 over the wet mixture in Bowl 1. Mix just until incorporated. Do not overmix. Pour into pans and immediately transfer to oven. Place a pan of water at the bottom of the oven and bake cakes for 2-3 hours. Check with a toothpick for doneness.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 2 9-inch cakes or 1 9x13 cake.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P66-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _vm._v("CHOCOLATE CAKE 5 WAYS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the best and easiest chocolate cake recipe. I’ve used it for about 20 years. When I make it at the restaurants, I mix several batches of the dry ingredients and store the extras for later. When it is time to make the cake, I just pull out one of the dry mixes, add the remaining wet ingredients, and bake. With all of the different ways to finish a chocolate cake, you will have trouble repeating the same one.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Chocolate Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1¾ cups flour")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¾ cup cocoa powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup buttermilk")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup coffee")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preheat oven to 350 degrees. In a large mixing bowl, sift together dry ingredients. In a separate bowl, combine wet ingredients and whisk until eggs and oil are incorporated. Add wet mixture to dry and stir until just combined. Do not overmix. Pour into two 9-inch lined and greased pans and bake for 30 minutes or until set and toothpick comes out clean. You will start to see the edges of the cake separating from the sides of the pan when done. Run a knife around the edge of the pan and allow to cool for at least 10 minutes before turning out onto parchment or a cooling rack. Layers must be completely cooled before icing.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Serves 12.")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Chocolate Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("6 oz. semisweet chocolate")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup butter, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. vanilla")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1¼ cups confectioners’ sugar")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Melt chocolate in a double boiler over medium heat, then remove from heat and allow to cool. In a stand mixer with a whisk attachment, cream butter with confectioners’ sugar. Add egg yolk and vanilla and beat on low. Add cooled melted chocolate and beat on high until fluffy.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('b', [_vm._v("German Chocolate Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¾ cup butter, melted")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ cups evaporated milk")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("6 egg yolks")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ cups coconut")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ cups chopped toasted pecans")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tsp. vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a saucepan over medium heat, whisk together sugar, melted butter, evaporated milk, and egg yolks, stirring constantly until thickened. Remove from heat and fold in coconut, pecans, and vanilla. Allow to cool before icing cake layers.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Chocolate Ganache")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ cups heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("24 oz. semisweet chocolate chips")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combine all ingredients in a double boiler over medium heat. Heat until smooth and shiny, stirring occasionally. Do not let steam from the double boiler near the chocolate as it may cause it to seize up or curdle. Allow ganache to cool to room temperature before pouring over chilled cake layers. Smooth with an offset spatula.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Whipped Ganache Frosting")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1½ cups heavy cream")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 tbsp. butter")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("24 oz. semisweet chocolate chips")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combine all ingredients in a double boiler over medium heat. Heat until smooth and shiny, stirring occasionally. Do not let steam from the double boiler near the chocolate as it may cause it to seize up or curdle. Allow ganache to cool to room temperature then add cooled ganache to a stand mixer. Using a whisk attachment, beat on high until ganache is light and fluffy with stiff peaks.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('b', [_vm._v("Chocolate Fudge Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("2 tbsp. cocoa powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup evaporated milk")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup butter")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combine all ingredients in a saucepan over medium heat. Heat until mixture begins to separate from the bottom of the pot when stirred (similar to the hard ball stage). Remove from heat and beat by hand until mixture begins to thicken. Spread on cake immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P70-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _vm._v("DIVINITY FUDGE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Candy making centers around the temperature of sugar. For fudge and pralines, the sugar will have to reach 240 degrees, or the “soft ball” stage, meaning that if you put a drop of the sugar mixture into cold water it will form a malleable ball. The higher the temperature you cook the sugar, the harder that ball will be when dropped into cold water. Popcorn balls require a “hard ball” stage—260 degrees—to achieve the sticky consistency. For sugar sculpting and brittle candies, the sugar must reach 300 degrees, or the “hard crack” stage. The temperature to which you heat your sugar mixture will dictate your final product.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When making candy with sugar it is also important to work in a dry environment or even better, on a dry day. When there is too much humidity in the air, the sugar can seize up and crystallize too quickly or not set up at all.")]), _vm._v(" "), _c('p', {
    staticClass: "ingre2"
  }, [_vm._v("3 cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("½ cup water")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("¾ cup light Karo syrup")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("3 egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("⅛ tsp. salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 tsp. vanilla")]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_vm._v("1 cup pecans")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a heavy saucepan over medium heat, combine sugar, water, and syrup. Stir to dissolve sugar and bring to a boil. Boil over medium heat until the temperature reaches 240 degrees, or the soft ball stage. Meanwhile, beat egg whites and salt in a stand mixer until the egg whites form stiff peaks. Slowly pour the hot syrup into the egg whites while the mixer is running at a medium speed. Beat the mixture for about 5 minutes, until it loses its shine. Either stir in pecan pieces and spoon by the tablespoonful onto waxed paper, or spoon out and immediately top with a pecan half. Work quickly as the fudge will set as it cools.")]), _vm._v(" "), _c('p', {
    staticClass: "makes"
  }, [_c('b', [_vm._v("Makes 24 pieces.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P72-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 84
// module chunks = 0